// Shared design system extracted from dashboard6.js (Matilda UI).
// Injected as a <style> tag by <Dashboard6Styles /> so it only applies while a migrated page is mounted.
const dashboard6Styles = `
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        :root {
          --font-sans: "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          --primary-green: #0EA84A;
        }

        #kt_app_root, #kt_app_root * {
          font-family: var(--font-sans);
        }

        *, *::before, *::after,
        .card-surface,
        .stat-subcard,
        .custom-card-modal,
        .btn,
        .card,
        .card-flush,
        .modal-content {
          box-shadow: none !important;
        }

        .card-surface {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #f1f5f9;
        }

        .stat-subcard {
          border-radius: 16px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        /* Prevent and remove any blue outline/border when focusing or clicking on recharts */
        .recharts-wrapper,
        .recharts-wrapper *,
        .recharts-wrapper:focus,
        .recharts-wrapper:focus-visible,
        .recharts-wrapper:active,
        .recharts-surface,
        .recharts-surface:focus,
        .recharts-surface:focus-visible,
        .recharts-responsive-container,
        .recharts-responsive-container:focus,
        .recharts-responsive-container:focus-visible {
          outline: none !important;
          outline-style: none !important;
          border: none !important;
          box-shadow: none !important;
        }

        /* Ensure Bootstrap tooltips have white backgrounds */
        .tooltip .tooltip-inner {
          background-color: #ffffff !important;
          color: #0f172a !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
          font-weight: 600;
          font-size: 11px;
        }
        .tooltip.bs-tooltip-top .tooltip-arrow::before,
        .tooltip.bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
          border-top-color: #ffffff !important;
        }
        .tooltip.bs-tooltip-bottom .tooltip-arrow::before,
        .tooltip.bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
          border-bottom-color: #ffffff !important;
        }

        .hero-stats-strip {
          background: linear-gradient(135deg, #065F46 0%, #0F9D58 45%, #12B76A 100%) !important;
          border-radius: 16px !important;
          border: none !important;
          padding: 20px 24px !important;
        }

        @media (min-width: 768px) {
          .hero-stat-col:not(:last-child) {
            border-right: 1px solid rgba(255, 255, 255, 0.25);
          }
        }

        /* Architectural Ken Burns Zoom Animation */
        @keyframes kenBurnsSlowZoom {
          0% {
            transform: scale(1.18);
          }
          100% {
            transform: scale(1.0);
          }
        }

        .ken-burns-hero {
          animation: kenBurnsSlowZoom 20s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          will-change: transform;
        }

        @keyframes residentPillFade {
          0% {
            opacity: 0.3;
            transform: translateY(6px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .resident-pill-anim {
          animation: residentPillFade 0.45s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        /* Vibrant lime / light green mesh card based on user image */
        .rent-revenue-mesh-card {
          background: #a3e635;
          background:
            radial-gradient(circle at 82% 18%, rgba(217, 249, 157, 0.95) 0%, transparent 42%),
            radial-gradient(circle at 18% 15%, rgba(190, 242, 100, 0.95) 0%, transparent 48%),
            radial-gradient(circle at 8% 82%, rgba(132, 204, 22, 0.9) 0%, transparent 52%),
            radial-gradient(circle at 88% 85%, rgba(74, 222, 128, 0.85) 0%, transparent 48%),
            radial-gradient(circle at 48% 45%, rgba(163, 230, 53, 0.9) 0%, transparent 50%),
            linear-gradient(135deg, #bef264 0%, #a3e635 45%, #84cc16 100%);
          border-radius: 24px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 12px 30px -10px rgba(132, 204, 22, 0.35);
        }

        .rent-revenue-mesh-card::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(255, 255, 255, 0.3) 12%, transparent 12.5%);
          background-size: 16px 16px;
          opacity: 0.25;
          pointer-events: none;
        }

        /* Animated arrow button */
        .d6-arrow-btn {
          transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
          cursor: pointer;
        }
        .d6-arrow-btn:hover {
          transform: scale(1.14);
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
        }
        .d6-arrow-icon {
          transition: transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
          display: inline-block;
        }
        .d6-arrow-btn:hover .d6-arrow-icon {
          transform: translate(2px, 2px) scale(1.18);
        }

        /* Search pill wrapper */
        .search-pill-wrapper {
          border: 1px solid #e2e8f0;
          transition: all 0.2s ease;
        }
        .search-pill-wrapper:focus-within {
          border-color: #10B981 !important;
          box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15) !important;
        }

        .spotlight-card {
          border-radius: 16px;
          min-height: 340px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .spotlight-card:hover .spotlight-bg-img:not(.ken-burns-hero) {
          transform: scale(1.06);
        }

        .spotlight-bg-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.92;
        }

        .spotlight-nav-btn {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          border: none;
          background: rgba(255,255,255,0.25);
          backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.15s ease;
        }

        .spotlight-nav-btn:hover {
          background: rgba(255,255,255,0.45);
        }

        .spotlight-resident-pill {
          background: rgba(22, 26, 32, 0.72);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 9999px;
        }

        .spotlight-indicator-dot {
          border: none;
          padding: 0;
          height: 7px;
          border-radius: 999px;
          transition: width 0.3s ease;
        }

        .progress-track {
          width: 100%;
          height: 10px;
          border-radius: 999px;
          background: #e2e8f0;
          overflow: hidden;
        }

        .progress-fill-gradient {
          height: 100%;
          border-radius: 999px;
        }

        .legend-dot {
          width: 8px;
          height: 8px;
          border-radius: 999px;
          display: inline-block;
        }

        .insights-bg {
          background-image: url(/assets/media/zangon/imageb.jpg);
          background-size: cover;
          background-position: center;
        }

        .insights-overlay {
          background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.85) 45%, rgba(0,0,0,0.55) 100%);
        }

        #kt_app_root { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
        #kt_app_header .fw-bolder, #kt_app_content_container .fw-bolder,
        #kt_app_header .fw-bold, #kt_app_content_container .fw-bold { font-weight: 600 !important; }
        #kt_app_header .fw-semibold, #kt_app_content_container .fw-semibold { font-weight: 500 !important; }
        #kt_app_content_container .fw-medium { font-weight: 400 !important; }
        #kt_app_header .btn, #kt_app_content_container .btn { font-weight: 500 !important; font-size: 13px !important; }
        #kt_app_content_container .fs-6 { font-size: 15px !important; }
        #kt_app_content_container .fs-7 { font-size: 14px !important; }
        #kt_app_content_container .fs-8 { font-size: 13px !important; }
        #kt_app_content_container .fs-9 { font-size: 11.5px !important; }

        .d6-page-title { font-size: 20px; font-weight: 600; letter-spacing: -0.01em; }
        .d6-greeting { font-size: 28px; font-weight: 500; letter-spacing: -0.02em; line-height: 1.15; }
        .d6-title { font-size: 16px; font-weight: 600; letter-spacing: -0.005em; line-height: 1.3; }
        .d6-hero-title { font-size: 28px; font-weight: 500; letter-spacing: -0.02em; line-height: 1.15; }
        .d6-num { font-size: 30px; font-weight: 500; letter-spacing: -0.02em; line-height: 1; }
        .d6-num-md { font-size: 24px; font-weight: 500; letter-spacing: -0.02em; line-height: 1; }
        .d6-num-suffix { font-size: 16px; font-weight: 400; letter-spacing: 0; }

        .d6-mbtn {
          height: 40px;
          padding: 0 20px !important;
          border-radius: 999px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          display: inline-flex !important;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
        }
        .d6-mbtn.btn-light { background: #f4f4f5 !important; color: #3f3f46 !important; border: 1px solid #e4e4e7 !important; }
        .d6-mbtn.btn-light:hover { background: #e9e9ec !important; color: #18181b !important; }
        .d6-mbtn i { color: inherit; }

        /* ---------- modal system ---------- */
        .d6m-dialog { width: calc(100% - 24px); margin-left: auto; margin-right: auto; }
        .d6m {
          height: min(88vh, 860px);
          display: flex;
          flex-direction: column;
          border: 0 !important;
          border-radius: 20px !important;
          overflow: hidden;
          position: relative;
          background: #ffffff;
          color: #18181b;
          box-shadow: 0 30px 80px -20px rgba(15, 23, 42, 0.35) !important;
        }
        .d6m-head { display: flex; align-items: center; gap: 14px; padding: 20px 24px; border-bottom: 1px solid #f0f0f2; flex-shrink: 0; }
        .d6m-head-icon {
          width: 40px; height: 40px; border-radius: 12px; background: #f4f4f5; color: #3f3f46;
          display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .d6m-head-icon i { color: inherit; font-size: 1.3rem; }
        .d6m-title { font-size: 17px; font-weight: 600; letter-spacing: -0.01em; color: #18181b; margin: 0; line-height: 1.3; }
        .d6m-x {
          width: 36px; height: 36px; border-radius: 999px; border: 0; background: transparent; color: #71717a;
          display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; transition: background 0.15s ease, color 0.15s ease;
        }
        .d6m-x:hover { background: #f4f4f5; color: #18181b; }
        .d6m-x i { color: inherit; font-size: 1.2rem; }
        .d6m-body { flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: 24px; }
        .d6m-body-fill { display: flex; flex-direction: column; padding: 0; overflow: hidden; }
        .d6m-foot {
          display: flex; align-items: center; justify-content: flex-end; gap: 8px;
          padding: 14px 24px; border-top: 1px solid #f0f0f2; background: #ffffff; flex-shrink: 0;
        }

        .d6m-tabs { display: flex; gap: 20px; padding: 0 24px; border-bottom: 1px solid #f0f0f2; flex-shrink: 0; }
        .d6m-tabs button {
          border: 0; background: none; padding: 12px 0 11px; font-size: 13.5px; font-weight: 500; color: #71717a;
          border-bottom: 2px solid transparent; display: inline-flex; align-items: center; transition: color 0.15s ease, border-color 0.15s ease;
        }
        .d6m-tabs button:hover { color: #18181b; }
        .d6m-tabs button.active { color: #18181b; border-bottom-color: #18181b; }

        .d6m-person { display: flex; align-items: center; gap: 14px; }
        .d6m-avatar {
          border-radius: 999px; background: #f4f4f5; color: #52525b; font-weight: 600; flex-shrink: 0; overflow: hidden;
          display: inline-flex; align-items: center; justify-content: center;
        }
        .d6m-avatar img { width: 100%; height: 100%; object-fit: cover; }
        .d6m-name { font-size: 15.5px; font-weight: 600; color: #18181b; line-height: 1.3; }
        .d6m-muted { font-size: 12.5px; color: #71717a; line-height: 1.45; }
        .d6m-k { display: block; font-size: 12px; color: #71717a; margin-bottom: 4px; }
        .d6m-v { font-size: 14px; font-weight: 500; color: #18181b; }
        .d6m-dot { width: 7px; height: 7px; border-radius: 999px; display: inline-block; flex-shrink: 0; }
        .d6m-chip {
          display: inline-flex; align-items: center; gap: 7px; padding: 5px 11px; border-radius: 999px;
          background: #f4f4f5; color: #3f3f46; font-size: 12.5px; font-weight: 500; white-space: nowrap; flex-shrink: 0;
        }
        .d6m-chip::before { content: ""; width: 7px; height: 7px; border-radius: 999px; background: var(--dot, #a1a1aa); }
        .d6m-count {
          display: inline-flex; align-items: center; justify-content: center; min-width: 20px; height: 20px; padding: 0 6px;
          border-radius: 999px; background: #f4f4f5; color: #52525b; font-size: 11.5px; font-weight: 600;
        }

        .d6m-kv { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); border: 1px solid #ececef; border-radius: 14px; overflow: hidden; }
        .d6m-kv-cell { padding: 14px 16px; min-width: 0; }
        .d6m-kv-cell + .d6m-kv-cell { border-left: 1px solid #ececef; }
        .d6m-kv-4 .d6m-kv-cell:nth-child(3) { border-left: 0; }
        .d6m-kv-4 .d6m-kv-cell:nth-child(n+3) { border-top: 1px solid #ececef; }
        .d6m-kv-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

        .d6m-section { margin-top: 28px; }
        .d6m-section-head {
          display: flex; align-items: center; justify-content: space-between; gap: 12px;
          font-size: 13px; font-weight: 600; color: #3f3f46; margin-bottom: 12px;
        }
        .d6m-section-head .d6m-muted { font-weight: 400; }
        .d6m-empty { padding: 28px 16px; text-align: center; color: #a1a1aa; font-size: 13px; border: 1px dashed #e4e4e7; border-radius: 14px; }
        .d6m-hint { font-size: 12px; color: #a1a1aa; margin-top: 6px; }
        .d6m-error { font-size: 12px; color: #dc2626; margin-top: 6px; }

        .d6m-invoice { border: 1px solid #ececef; border-radius: 14px; padding: 16px; }
        .d6m-invoice + .d6m-invoice { margin-top: 10px; }
        .d6m-amount { font-size: 22px; font-weight: 500; letter-spacing: -0.02em; line-height: 1.1; color: #18181b; }
        .d6m-lines { margin-top: 14px; background: #fafafa; border-radius: 10px; padding: 4px 14px; }
        .d6m-line { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 9px 0; font-size: 13px; color: #52525b; }
        .d6m-line span:last-child { color: #18181b; font-variant-numeric: tabular-nums; }
        .d6m-line + .d6m-line { border-top: 1px solid #f0f0f2; }
        .d6m-line-total { font-weight: 600; color: #18181b; }

        .d6m-property { display: flex; align-items: center; gap: 14px; border: 1px solid #ececef; border-radius: 14px; padding: 12px; }
        .d6m-property img { width: 64px; height: 64px; border-radius: 10px; object-fit: cover; flex-shrink: 0; }

        .d6m-issue-title { font-size: 15px; font-weight: 600; color: #18181b; line-height: 1.45; }
        .d6m-issue-desc { font-size: 14px; color: #52525b; line-height: 1.65; margin: 6px 0 0; white-space: pre-line; }
        .d6m-attachments { display: grid; grid-template-columns: repeat(auto-fill, minmax(88px, 1fr)); gap: 10px; }
        .d6m-thumb { aspect-ratio: 1; border: 1px solid #ececef; border-radius: 12px; overflow: hidden; padding: 0; background: #fafafa; transition: transform 0.2s ease; }
        .d6m-thumb:hover { transform: translateY(-2px); }
        .d6m-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .d6m-file {
          display: inline-flex; align-items: center; gap: 8px; padding: 0 12px; height: 40px; border: 1px solid #ececef; border-radius: 10px;
          font-size: 13px; color: #3f3f46; grid-column: span 2;
        }
        .d6m-file i { color: #71717a; }

        .d6m-seg { display: flex; gap: 4px; padding: 4px; background: #f4f4f5; border-radius: 999px; }
        .d6m-seg button {
          flex: 1; height: 38px; border: 0; background: transparent; border-radius: 999px; color: #52525b;
          font-size: 13px; font-weight: 500; display: inline-flex; align-items: center; justify-content: center; gap: 8px;
          transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
        }
        .d6m-seg button i { color: inherit; font-size: 1.05rem; }
        .d6m-seg button:hover:not(:disabled) { color: #18181b; }
        .d6m-seg button.active { background: #ffffff; color: #18181b; box-shadow: 0 1px 3px rgba(0,0,0,0.08) !important; }

        .d6m-thread { flex: 1 1 auto; min-height: 0; overflow-y: auto; padding: 20px 24px; display: flex; flex-direction: column; gap: 16px; }
        .d6m-thread > .d6m-empty { margin: auto 0; border: 0; }
        .d6m-msg { display: flex; align-items: flex-end; gap: 10px; max-width: 85%; }
        .d6m-msg.mine { align-self: flex-end; flex-direction: row-reverse; }
        .d6m-msg-body { min-width: 0; }
        .d6m-msg-meta { display: flex; gap: 8px; font-size: 11.5px; color: #a1a1aa; margin-bottom: 4px; }
        .d6m-msg-meta span:first-child { color: #52525b; font-weight: 500; }
        .d6m-msg.mine .d6m-msg-meta { justify-content: flex-end; }
        .d6m-bubble {
          background: #ffffff; border: 1px solid #ececef; border-radius: 14px 14px 14px 4px; padding: 10px 14px;
          font-size: 13.5px; line-height: 1.55; color: #27272a; white-space: pre-line; word-break: break-word;
        }
        .d6m-msg.mine .d6m-bubble { background: #f4f4f5; border-color: #f4f4f5; border-radius: 14px 14px 4px 14px; }
        .d6m-composer { display: flex; align-items: flex-end; gap: 10px; padding: 14px 24px; border-top: 1px solid #f0f0f2; flex-shrink: 0; }
        .d6m-composer textarea {
          flex: 1; resize: none; border: 1px solid #e4e4e7; border-radius: 14px; padding: 10px 14px; font-size: 13.5px;
          line-height: 1.5; outline: none; transition: border-color 0.15s ease, box-shadow 0.15s ease; min-height: 44px; max-height: 140px;
        }
        .d6m-composer textarea:focus { border-color: #a1a1aa; box-shadow: 0 0 0 3px rgba(24, 24, 27, 0.06); }

        .d6m-field label { display: block; font-size: 12.5px; font-weight: 500; color: #3f3f46; margin-bottom: 6px; }
        .d6m-input, .d6m-input-group {
          width: 100%; min-height: 42px; border: 1px solid #e4e4e7; border-radius: 10px; background: #ffffff;
          font-size: 14px; color: #18181b; transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }
        .d6m-input { padding: 9px 12px; outline: none; }
        textarea.d6m-input { resize: vertical; line-height: 1.5; }
        select.d6m-input { appearance: none; -webkit-appearance: none; padding-right: 40px; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none' stroke='%2371717a' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M1 1.5l5 5 5-5'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 16px center; background-size: 12px 8px; }
        .d6m-input::placeholder, .d6m-input-group input::placeholder { color: #a1a1aa; }
        .d6m-input:focus, .d6m-input-group:focus-within { border-color: #a1a1aa; box-shadow: 0 0 0 3px rgba(24, 24, 27, 0.06); }
        .d6m-input.is-readonly { background: #fafafa; color: #52525b; }
        .d6m-input.is-invalid, .d6m-input-group.is-invalid { border-color: #fca5a5; }
        .d6m-input-group { display: flex; align-items: center; overflow: hidden; }
        .d6m-input-group span { padding: 0 12px; color: #71717a; font-size: 14px; border-right: 1px solid #ececef; align-self: stretch; display: flex; align-items: center; background: #fafafa; }
        .d6m-input-group input { flex: 1; border: 0; outline: none; padding: 9px 12px; font-size: 14px; background: transparent; min-width: 0; }

        .d6m-upload { display: flex; align-items: center; gap: 14px; padding: 14px; border: 1px solid #ececef; border-radius: 14px; }
        .d6m-upload-preview {
          width: 56px; height: 56px; border-radius: 999px; border: 1px dashed #d4d4d8; background: #fafafa; color: #a1a1aa; padding: 0;
          display: inline-flex; align-items: center; justify-content: center; overflow: hidden; flex-shrink: 0;
        }
        .d6m-upload-preview img { width: 100%; height: 100%; object-fit: cover; }
        .d6m-upload-preview i { color: inherit; font-size: 1.5rem; }
        .d6m-link-btn { border: 0; background: none; padding: 0; font-size: 13px; font-weight: 500; color: #52525b; text-decoration: underline; text-underline-offset: 3px; }
        .d6m-link-btn:hover { color: #18181b; }
        .d6-mbtn-sm { height: 34px !important; padding: 0 14px !important; }

        .d6m-note {
          display: flex; gap: 10px; align-items: flex-start; margin-top: 28px; padding: 12px 14px; border-radius: 12px;
          background: #fafafa; color: #52525b; font-size: 12.5px; line-height: 1.5;
        }
        .d6m-note i { color: #a1a1aa; font-size: 1.1rem; margin-top: 1px; }

        .d6m-card { border: 1px solid #ececef; border-radius: 16px; padding: 18px; }
        .d6m-list { display: flex; flex-direction: column; border: 1px solid #ececef; border-radius: 14px; overflow: hidden; }
        .d6m-list-row {
          display: flex; align-items: center; gap: 12px; width: 100%; padding: 12px 14px; border: 0; background: #ffffff;
          text-align: left; cursor: pointer; transition: background 0.15s ease; margin: 0;
        }
        .d6m-list-row + .d6m-list-row { border-top: 1px solid #f0f0f2; }
        .d6m-list-row:hover { background: #fafafa; }
        .d6m-list-row.active { background: #f7f7f8; }
        .d6m-tile { width: 40px; height: 40px; border-radius: 10px; background: #f4f4f5; color: #3f3f46; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .d6m-tile i { color: inherit; font-size: 1.25rem; }
        .d6m-edit { font-size: 12.5px; color: #a1a1aa; font-weight: 500; flex-shrink: 0; }
        .d6m-list-row:hover .d6m-edit, .d6m-list-row.active .d6m-edit { color: #18181b; }
        .d6m-check-row input { position: absolute; opacity: 0; pointer-events: none; }
        .d6m-check {
          width: 20px; height: 20px; border-radius: 6px; border: 1.5px solid #d4d4d8; background: #ffffff; flex-shrink: 0;
          display: inline-flex; align-items: center; justify-content: center; transition: background 0.15s ease, border-color 0.15s ease;
        }
        .d6m-check svg { width: 14px; height: 14px; fill: none; stroke: #ffffff; stroke-width: 3; stroke-linecap: round; stroke-linejoin: round; opacity: 0; transition: opacity 0.15s ease; }
        .d6m-check-row.active .d6m-check { background: #18181b; border-color: #18181b; }
        .d6m-check-row.active .d6m-check svg { opacity: 1; }
        .d6m-check-row:focus-within .d6m-check { box-shadow: 0 0 0 3px rgba(24, 24, 27, 0.12); }

        .d6m-shimmer {
          display: inline-block;
          background: linear-gradient(90deg, #f1f1f3 0%, #f8f8fa 50%, #f1f1f3 100%);
          background-size: 200% 100%;
          animation: d6mShimmer 1.3s ease-in-out infinite;
          flex-shrink: 0;
        }
        .d6m-shimmer.mt-2, .d6m-shimmer.mt-3 { display: block; }
        @keyframes d6mShimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }
        .d6m .dropdown .form-select { min-height: 42px; border-radius: 10px; border-color: #e4e4e7; font-size: 14px; }

        @media (max-width: 575.98px) {
          .d6m { height: calc(100vh - 24px); }
          .d6m-kv { grid-template-columns: minmax(0, 1fr); }
          .d6m-kv-cell + .d6m-kv-cell { border-left: 0; border-top: 1px solid #ececef; }
        }

        .d6-mbtn-sent { background: #065d38 !important; border-color: #065d38 !important; }
        .d6-mini-tick { width: 16px; height: 16px; fill: none; stroke: #ffffff; stroke-width: 2.6; stroke-linecap: round; stroke-linejoin: round; stroke-dasharray: 24; stroke-dashoffset: 24; animation: d6Draw 0.4s ease forwards; }
        .d6-bubble-in { animation: d6BubbleIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) both; }
        @keyframes d6BubbleIn { from { opacity: 0; transform: translateY(10px) scale(0.98); } to { opacity: 1; transform: none; } }

        /* ---------- success state ---------- */
        .d6-success {
          position: absolute; inset: 0; z-index: 30;
          display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;
          padding: 32px;
          background: rgba(255, 255, 255, 0.92);
          backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
          animation: d6FadeIn 0.3s ease both;
        }
        .d6-success-burst { position: relative; width: 220px; height: 220px; display: flex; align-items: center; justify-content: center; }
        .d6-success-ring { position: absolute; border-radius: 999px; border: 1px solid rgba(16, 185, 129, 0.14); background: rgba(236, 253, 245, 0.35); }
        .d6-success-ring-lg { inset: 0; animation: d6RingPulse 2.6s ease-out infinite; }
        .d6-success-ring-md { inset: 28px; animation: d6RingPulse 2.6s ease-out 0.35s infinite; }
        .d6-success-dot { position: absolute; border-radius: 999px; background: #86efac; opacity: 0; animation: d6DotFloat 2.4s ease-in-out infinite; }
        .d6-success-check { position: relative; width: 132px; height: 132px; animation: d6Pop 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) both; }
        .d6-success-halo { fill: none; stroke: #a7f3d0; stroke-width: 2; opacity: 0.8; }
        .d6-success-fill { fill: #ecfdf5; }
        .d6-success-stroke {
          fill: none; stroke: #10b981; stroke-width: 6; stroke-linecap: round;
          stroke-dasharray: 277; stroke-dashoffset: 277;
          transform: rotate(-90deg); transform-origin: 60px 60px;
          animation: d6Draw 0.7s cubic-bezier(0.65, 0, 0.35, 1) 0.1s forwards;
        }
        .d6-success-tick {
          fill: none; stroke: #059669; stroke-width: 8; stroke-linecap: round; stroke-linejoin: round;
          stroke-dasharray: 64; stroke-dashoffset: 64;
          animation: d6Draw 0.45s cubic-bezier(0.65, 0, 0.35, 1) 0.6s forwards;
        }
        .d6-success-title { margin: 18px 0 8px; font-size: 30px; font-weight: 500; letter-spacing: -0.02em; color: #0f172a; animation: d6Rise 0.5s ease 0.5s both; }
        .d6-success-msg { max-width: 420px; margin: 0; font-size: 15px; line-height: 1.6; color: #64748b; animation: d6Rise 0.5s ease 0.62s both; }
        .d6-success-progress { width: 180px; height: 4px; border-radius: 999px; background: #eef2f0; overflow: hidden; margin-top: 36px; }
        .d6-success-progress span { display: block; height: 100%; width: 0; border-radius: 999px; background: #10b981; animation-name: d6Progress; animation-timing-function: linear; animation-fill-mode: forwards; }
        @keyframes d6Draw { to { stroke-dashoffset: 0; } }
        @keyframes d6Pop { from { opacity: 0; transform: scale(0.6); } to { opacity: 1; transform: scale(1); } }
        @keyframes d6Rise { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
        @keyframes d6FadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes d6Progress { from { width: 0; } to { width: 100%; } }
        @keyframes d6RingPulse { 0% { transform: scale(0.92); opacity: 0; } 30% { opacity: 1; } 100% { transform: scale(1.06); opacity: 0; } }
        @keyframes d6DotFloat { 0%, 100% { opacity: 0; transform: translateY(4px); } 40%, 60% { opacity: 0.9; transform: translateY(-4px); } }
        @media (prefers-reduced-motion: reduce) {
          .d6-success *, .d6-success, .d6-bubble-in, .d6-mini-tick { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; }
          .d6-success-stroke, .d6-success-tick, .d6-mini-tick { stroke-dashoffset: 0; }
        }

        .d6-list-card { border-radius: 16px !important; }

        .d6-card {
          background: #ffffff;
          border: 1px solid #eceef1;
          border-radius: 16px;
          transition: border-color 0.2s ease, transform 0.2s ease;
        }
        .d6-card:hover { border-color: #d9dee4; }

        .d6-kpi {
          min-height: 205px;
        }
        .d6-kpi-brand {
          background:
            radial-gradient(circle at 88% 12%, rgba(163, 230, 53, 0.45) 0%, transparent 45%),
            radial-gradient(circle at 10% 100%, rgba(6, 93, 56, 0.9) 0%, transparent 60%),
            linear-gradient(135deg, #0EA84A 0%, #0B7F3B 55%, #065d38 100%);
          border: 1px solid rgba(6, 93, 56, 0.4);
          border-radius: 16px;
          color: #ffffff;
          position: relative;
          overflow: hidden;
        }
        .d6-kpi-brand::after {
          content: "";
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(255, 255, 255, 0.35) 1px, transparent 1.5px);
          background-size: 14px 14px;
          -webkit-mask-image: linear-gradient(200deg, #000 0%, transparent 55%);
          mask-image: linear-gradient(200deg, #000 0%, transparent 55%);
          pointer-events: none;
        }

        .d6-icon-btn {
          width: 32px;
          height: 32px;
          border-radius: 10px;
          border: 1px solid #e4e7eb;
          background: #ffffff;
          color: #71717a;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
          text-decoration: none;
          flex-shrink: 0;
        }
        .d6-icon-btn i { color: inherit; }
        .d6-icon-btn:hover { color: #065d38; border-color: #bfe6cd; background: #f3fbf6; }
        .d6-icon-btn.on-brand { background: rgba(255,255,255,0.18); border-color: rgba(255,255,255,0.3); color: #ffffff; }
        .d6-icon-btn.on-brand:hover { background: rgba(255,255,255,0.3); }

        .d6-seg {
          display: inline-flex;
          align-items: center;
          gap: 2px;
          padding: 3px;
          border-radius: 999px;
          background: #f4f4f5;
        }
        .d6-seg button {
          border: 0;
          background: transparent;
          color: #71717a;
          padding: 5px 12px;
          border-radius: 999px;
          transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
        }
        .d6-seg button:hover { color: #18181b; }
        .d6-seg button.active { background: #ffffff; color: #18181b; box-shadow: 0 1px 3px rgba(0,0,0,0.08) !important; }

        .d6-tooltip {
          background: #ffffff;
          border: 1px solid #e4e7eb;
          border-radius: 12px;
          padding: 8px 12px;
          min-width: 150px;
          box-shadow: 0 10px 24px -8px rgba(15, 23, 42, 0.18) !important;
        }

        .d6-meter-track { height: 6px; border-radius: 999px; background: #eef0f2; overflow: hidden; }
        .d6-meter-fill { height: 100%; border-radius: 999px; transition: width 0.9s cubic-bezier(0.16, 1, 0.3, 1); }

        .d6-list-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 8px;
          margin: 0 -8px;
          border-radius: 12px;
          cursor: pointer;
          transition: background 0.15s ease;
        }
        .d6-list-row:hover { background: #f6faf7; }
        .d6-list-row + .d6-list-row { border-top: 1px solid #f1f3f5; }


        .d6-gauge-seg { transition: opacity 0.2s ease; cursor: pointer; transform-origin: 100px 104px; animation: d6SegIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) both; }
        @keyframes d6SegIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
        .d6-gauge-legend { display: grid; gap: 6px; margin-top: 18px; padding-top: 14px; border-top: 1px solid #f1f3f5; }
        .d6-gauge-key {
          display: flex; flex-direction: column; align-items: center; gap: 1px; border: 0; background: transparent;
          padding: 6px 4px; border-radius: 10px; transition: background 0.15s ease; min-width: 0;
        }
        .d6-gauge-key:hover, .d6-gauge-key.on { background: #f6faf7; }
`;

export default dashboard6Styles;
